<template>
    <footer class="mt-3 w-100 text-center text-blurikorda">
        <div v-if="showRikorda">
            <small v-html="rikordaFooterText"></small>
        </div>

        <div v-if="!showRikorda">
            <small v-html="footerText"></small><small> |
                <a
                    href="#"
                    @click.prevent="onShowTerms()"
                >{{ $t("Termini e condizioni") }}
                </a> | <a
                    href="#"
                    @click.prevent="onShowPrivacy()"
                >{{ $t("Privacy") }}
                </a>
            </small>
        </div>

        <GDPRViewer
            ref="viewerFooter"
            :gdpr="gdprToView"
            :shop="storedShop"
            :hasCustomGdpr="hasCustomGdpr"
            :isClientTerms="isClientTerms"
        >
            <slot></slot>
        </GDPRViewer>

    </footer>
</template>

<script>
import GDPRViewer from "../GDPRViewer";

export default {
    name: "GalleryFooter",

    components: { GDPRViewer },

    props: {
        showRikorda: { type: Boolean, default: false }
    },

    data() {
        return {
            gdprToView: null,
            isClientTerms: false,
            hasCustomGdpr: false,
            rikordaFooterText:
                "&copy; Copyright 2018 Rikorda. Rikorda SC.A.R.L Sede Legale: Via Santuario, n.3 - 12012 Boves CN | P.I./C.F: 01931960064 " +
                "| Capitale sociale 60.000 i.v. Iscritta al Reg. Imprese di Cuneo n. 01931960064 | REA n. 285442"
        };
    },

    methods: {
        onShowTerms() {
            console.debug("onShowTerms", this.storedShopData);
            // Termini e condizioni tra negoziante e utente finale
            this.hasCustomGdpr = false;
            this.isClientTerms = true;
            if (
                this.showRikorda &&
                this.storedShopData &&
                this.storedShopData.docs &&
                this.storedShopData.docs.default &&
                this.storedShopData.docs.default.TerminiCondizioniRikordaUtenti
            ) {
                this.gdprToView = this.storedShopData.docs.default.TerminiCondizioniRikordaUtenti;
                this.$bvModal.show(this.$refs.viewerFooter.id);
            } else if (
                !this.showRikorda &&
                this.storedShopData &&
                this.storedShopData.docs &&
                this.storedShopData.docs.default &&
                this.storedShopData.docs.default
                    .TerminiCondizioniFotografoUtenti
            ) {
                this.gdprToView = this.storedShopData.docs.default.TerminiCondizioniFotografoUtenti;
                this.$bvModal.show(this.$refs.viewerFooter.id);
            }
        },

        onShowPrivacy() {
            console.debug("onShowPrivacy");
            // Informativa privacy all'utente finale (default o personalizzata)
            this.hasCustomGdpr =
                this.storedShopData &&
                this.storedShopData.docs &&
                this.storedShopData.docs.custom &&
                this.storedShopData.docs.custom.fkUtente;
            this.isClientTerms = false;
            if (
                this.storedShopData &&
                this.storedShopData.docs &&
                this.storedShopData.docs.default &&
                this.storedShopData.docs.default.Informativa
            ) {
                this.gdprToView = this.storedShopData.docs.default.Informativa;

                var shop = this.storedShopData.shop;
                Array.from(Object.keys(shop)).forEach((el) => {
                    if (el.toLowerCase() === "dpo") {
                        this.gdprToView = this.gdprToView.replaceAll(
                            "[[__DPO__]]",
                            shop[el] ? shop[el] : "non è stato individuato"
                        );
                    }
                    this.gdprToView = this.gdprToView.replaceAll(
                        "[[__" + el.toUpperCase() + "__]]",
                        shop[el]
                    );
                });
                this.$bvModal.show(this.$refs.viewerFooter.id);
            }
        }
    },

    computed: {
        storedShopData() {
            return this.$store.getters.shopData;
        },
        storedShop() {
            return this.storedShopData && this.storedShopData.shop;
        },
        footerText() {
            if (this.storedShop && this.storedShop.ragioneSociale) {
                return (
                    "Copyright &copy;2020 " +
                    this.storedShop.ragioneSociale.toUpperCase() +
                    " Tutti i diritti riservati " +
                    this.storedShop.indirizzo.toUpperCase() +
                    " - " +
                    this.storedShop.cap +
                    " " +
                    this.storedShop.citta.toUpperCase() +
                    " " +
                    this.storedShop.provincia.toUpperCase() +
                    " | P.I/C.F: " +
                    this.storedShop.piva +
                    " | Email: " +
                    this.storedShop.email +
                    " | Tel: " +
                    this.storedShop.telefono
                );
            }
            return this.rikordaFooterText;
        }
    }
};
</script>

<style>
</style>
